//@flow
const questionMarkSource = require("./question-mark/question-mark.png");

const iconImageAssets = {
  questionMarkSource
};

export { iconImageAssets };
export type IconImageAssetType = $Values<typeof iconImageAssets>;
